module.exports = __webpack_public_path__ + "static/media/HYDE.37694528.png";